import { SVG } from '../svg';
import { IconProps } from '../types';

export function CircleAlertFilledIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props} colorTarget="fill">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"></path>
    </SVG>
  );
}
